import IComic from '#/types/comics';

export const ComicDetailsActionType = {
  COMIC_DETAILS_SET_COMIC_DETAILS: 'comic_details/set_comic_details',
} as const;

export type TComicDetailsActions = {
  type: typeof ComicDetailsActionType.COMIC_DETAILS_SET_COMIC_DETAILS;
  payload: IComic | undefined;
};
